module.exports = __webpack_public_path__ + "media/shaomiao.2d35c587.mp4";